<template>
    <div class="model-upload-container">
        <!-- 头部组件 -->
        <!-- <Top /> -->
        <div class="auth-modal" v-if="showAuthModal">
            <div class="auth-modal-content">
                <h3 class="auth-modal-title">实名认证提醒</h3>
                <p class="auth-modal-desc">{{ authModalText }}</p>
                <button class="auth-modal-btn" @click="goToAuthPage">去完善</button>
            </div>
        </div>
        <!-- 步骤条区域 -->
        <div class="steps">
            <div class="steps-wrapper">
                <!-- 步骤1：上传模型配图 -->
                <div class="step-item" :class="{ 'step-active': currentStep === 1 }">
                    <div class="step-icon">
                        <i class="el-icon-upload"></i>
                    </div>
                    <div class="step-text">1.上传模型配图</div>
                </div>
                <!-- 步骤连接线 -->
                <div class="step-line"
                    :class="{ 'step-line-active': currentStep >= 2, 'step-line-inactive': currentStep < 2 }"></div>
                <!-- 步骤2：填写模型介绍 -->
                <div class="step-item" :class="{ 'step-active': currentStep === 2 }">
                    <div class="step-icon">
                        <i class="el-icon-edit"></i>
                    </div>
                    <div class="step-text">2.填写模型介绍</div>
                </div>
                <!-- 步骤连接线 -->
                <div class="step-line"
                    :class="{ 'step-line-active': currentStep >= 3, 'step-line-inactive': currentStep < 3 }"></div>
                <!-- 步骤3：发布等待审核 -->
                <div class="step-item" :class="{ 'step-active': currentStep === 3 }">
                    <div class="step-icon">
                        <i class="el-icon-circle-check"></i>
                    </div>
                    <div class="step-text">3.发布等待审核</div>
                </div>
            </div>
        </div>

        <!-- 主体内容区 -->
        <div class="main">
            <!-- 左侧上传表单区 -->
            <div class="upload-content">
                <el-card class="upload-card" shadow="hover">
                    <!-- 步骤1：上传模型配图 -->
                    <div v-if="currentStep === 1" class="step-content">
                        <el-form ref="uploadForm" :model="form" label-width="120px" :rules="formRules"
                            class="upload-form">
                            <!-- 1. 上传预览图 -->
                            <el-form-item label="上传预览图" prop="previewImages">
                                <template slot="label">
                                    <span style="color: #fff">上传预览图</span>
                                </template>
                                <el-upload class="preview-upload" list-type="picture-card" action=""
                                    :on-preview="handlePicturePreview" :on-remove="handlePreviewRemove"
                                    :on-success="handlePreviewSuccess" :file-list="form.previewImages" :limit="5"
                                    :on-exceed="handleFileExceed" :before-upload="beforeImageUpload"
                                    accept="image/jpeg,image/png,image/webp"
                                    :http-request="(params) => uploadFile(params, 'preview')">
                                    <i class="el-icon-plus upload-plus-icon"></i>
                                    <div slot="tip" class="upload-tip">
                                        支持JPG/PNG/WEBP格式，最多上传5张，单张不超过1MB（第一张为封面图）
                                    </div>
                                </el-upload>
                            </el-form-item>

                            <!-- 2. 上传线框图 -->
                            <el-form-item label="上传线框图" prop="wireframeImages">
                                <template slot="label">
                                    <span style="color: #fff">上传线框图</span>
                                </template>
                                <el-upload class="wireframe-upload" list-type="picture-card" action=""
                                    :on-preview="handlePicturePreview" :on-remove="handleWireframeRemove"
                                    :on-success="handleWireframeSuccess" :file-list="form.wireframeImages" :limit="5"
                                    :on-exceed="handleFileExceed" :before-upload="beforeImageUpload"
                                    accept="image/jpeg,image/png,image/svg+xml"
                                    :http-request="(params) => uploadFile(params, 'wireframe')">
                                    <i class="el-icon-plus upload-plus-icon"></i>
                                    <div slot="tip" class="upload-tip">
                                        支持JPG/PNG/SVG格式，最多上传5张，单张不超过1MB（清晰展示模型结构）
                                    </div>
                                </el-upload>
                            </el-form-item>

                            <!-- 3. 上传压缩包 -->
                            <!-- 3. 上传压缩包 -->
                            <el-form-item label="上传压缩包" prop="modelFile">
                                <template slot="label">
                                    <span style="color: #fff">上传压缩包</span>
                                </template>
                                <!-- ========== 核心：绑定 disabled 为 isModelUploading，上传中禁用整个上传组件 ========== -->
                                <el-upload class="model-file-upload" list-type="text" :on-remove="handleModelFileRemove"
                                    action="" :on-success="handleModelFileSuccess" :file-list="form.modelFile"
                                    :limit="5" :on-exceed="handleFileExceed" :before-upload="beforeModelFileUpload"
                                    accept=".zip,.rar,.7z,.tar,.gz,.bz2,.xz,.iso,.cab,.lzh,.arj"
                                    :http-request="(params) => uploadFile(params, 'model')"
                                    :disabled="isModelUploading">
                                    <!-- 关键：上传中禁用整个 el-upload 组件 -->
                                    <el-button size="small" type="primary" icon="el-icon-upload2">选择压缩包</el-button>
                                    <div slot="tip" class="upload-tip" style="color: #cbd5e1;">
                                        支持ZIP/RAR/7Z/TAR/GZ等压缩包格式，单个压缩包不超过1GB，最多上传5个
                                    </div>
                                </el-upload>

                                <!-- 进度条（保持不变） -->
                                <div v-if="isModelUploading" class="model-upload-progress" style="margin-top: 10px;">
                                    <!-- 优化：显示文件名 + 分片进度 + 整体进度 -->
                                    <div style="color: #cbd5e1; font-size: 12px; margin-bottom: 5px;">
                                        正在上传：{{ currentUploadFileName }}
                                        <!-- （分片 {{ currentChunkIndex + 1 }}/{{ totalUploadChunks }}，整体 {{ uploadProgress
                                        }}%） -->
                                        （进度{{ uploadProgress }}%）
                                    </div>
                                    <el-progress :percentage="uploadProgress" status="success" :stroke-width="6"
                                        style="background-color: #0f1118;">
                                    </el-progress>
                                </div>
                            </el-form-item>

                            <!-- 4. 文件格式配置组（支持多套） -->
                            <el-form-item label="文件格式配置" prop="formatConfigs">
                                <template slot="label">
                                    <span style="color: #fff">文件格式配置</span>
                                </template>
                                <div class="format-config-group">
                                    <!-- 动态渲染多套配置 -->
                                    <div v-for="(config, index) in form.formatConfigs" :key="index" class="config-item">
                                        <div class="config-header">
                                            <span class="config-index" style="color: rgb(203, 213, 225);">配置{{ index + 1
                                                }}</span>
                                            <el-button v-if="form.formatConfigs.length > 1" type="text"
                                                icon="el-icon-delete" @click="removeConfig(index)"
                                                class="delete-config-btn" style="margin-left: 10px;">
                                                删除
                                            </el-button>
                                        </div>

                                        <!-- 文件格式 -->
                                        <el-form-item :prop="`formatConfigs[${index}].fileFormat`" :rules="[
                                            { required: true, message: '请选择文件格式', trigger: 'blur' }
                                        ]" style="margin-bottom: 15px;" class="format-select-form-item">
                                            <template slot="label">
                                                <span style="color: #fff">文件格式</span>
                                            </template>
                                            <el-select :popper-append-to-body="false" v-model="config.fileFormat"
                                                placeholder="请选择文件格式" @change="handleFileFormatChange(index)"
                                                @blur="validateField(`formatConfigs[${index}].fileFormat`)"
                                                style="width: 300px;">
                                                <el-option v-for="item in FormatRenderers" :key="item.fileFormat"
                                                    :label="item.fileFormat" :value="item.fileFormat" />
                                            </el-select>
                                        </el-form-item>

                                        <!-- 格式版本 -->
                                        <el-form-item :prop="`formatConfigs[${index}].formatVersion`" :rules="[
                                            { required: config.needFormatVersion, message: '请输入格式版本', trigger: 'blur' },
                                            { max: 50, message: '版本长度不能超过50个字符', trigger: 'blur' }
                                        ]" v-if="config.needFormatVersion" style="margin-bottom: 15px;"
                                            class="format-select-form-item">
                                            <template slot="label">
                                                <span style="color: #fff">格式版本</span>
                                            </template>
                                            <el-input v-model="config.formatVersion" placeholder="请输入格式版本（如 2023、v4.5）"
                                                maxlength="50"
                                                @blur="validateField(`formatConfigs[${index}].formatVersion`)"
                                                style="width: 300px;" />
                                        </el-form-item>

                                        <!-- 渲染器 -->
                                        <el-form-item :prop="`formatConfigs[${index}].renderer`" :rules="[
                                            { required: config.needRenderer, message: '请选择渲染器', trigger: 'blur' }
                                        ]" v-if="config.needRenderer" style="margin-bottom: 15px;"
                                            class="format-select-form-item">
                                            <template slot="label">
                                                <span style="color: #fff">渲染器</span>
                                            </template>
                                            <el-select :popper-append-to-body="false" v-model="config.renderer"
                                                placeholder="请选择渲染器" @change="handleRendererChange(index)"
                                                @blur="validateField(`formatConfigs[${index}].renderer`)"
                                                style="width: 300px;">
                                                <el-option v-for="(rendererItem, idx) in config.rendererOptions || []"
                                                    :key="`renderer-${index}-${idx}`" :label="rendererItem.renderer"
                                                    :value="rendererItem.renderer" />
                                            </el-select>
                                        </el-form-item>

                                        <!-- 渲染器版本 -->
                                        <el-form-item :prop="`formatConfigs[${index}].rendererVersion`" :rules="[
                                            { required: config.needRendererVersion, message: '请输入渲染器版本', trigger: 'blur' },
                                            { max: 50, message: '版本长度不能超过50个字符', trigger: 'blur' }
                                        ]" v-if="config.needRendererVersion" class="format-select-form-item">
                                            <template slot="label">
                                                <span style="color: #fff">渲染器版本</span>
                                            </template>
                                            <el-input v-model="config.rendererVersion"
                                                placeholder="请输入该渲染器的版本（如 2024.1、v5.0）" maxlength="50"
                                                @blur="validateField(`formatConfigs[${index}].rendererVersion`)"
                                                style="width: 300px;" />
                                        </el-form-item>
                                    </div>

                                    <!-- 添加配置按钮 -->
                                    <el-button type="text" icon="el-icon-plus" @click="addConfig"
                                        class="add-config-btn">
                                        添加文件格式配置
                                    </el-button>
                                </div>
                            </el-form-item>

                            <!-- 8. 发布模式 -->
                            <el-form-item label="发布模式" prop="publishMode">
                                <template slot="label">
                                    <span style="color: #fff">发布模式</span>
                                </template>
                                <el-radio-group v-model="form.publishMode" @change="handlePublishModeChange"
                                    @blur="validateField('publishMode')" class="publish-mode-group">
                                    <el-radio label="free" class="publish-mode-item">免费分享</el-radio>
                                    <el-radio label="sale" class="publish-mode-item">素材出售</el-radio>
                                </el-radio-group>

                                <!-- 价格输入框 -->
                                <div v-if="form.publishMode === 'sale'" class="price-input-container">
                                    <el-form-item prop="authorizationPrice">
                                        <el-input v-model.number="form.authorizationPrice" placeholder="请输入个人授权价格（云币）"
                                            @blur="validateField('authorizationPrice')" class="price-input">
                                            <template slot="append">云币</template>
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </el-form-item>

                            <!-- 表单操作按钮 -->
                            <el-form-item class="form-btn-group">
                                <el-button type="default" @click="handleReset">重置</el-button>
                                <el-button type="primary" @click="handleNextStep">下一步：填写介绍</el-button>
                            </el-form-item>
                        </el-form>
                    </div>

                    <!-- 步骤2：填写模型介绍 -->
                    <div v-if="currentStep === 2" class="step-content">
                        <el-form ref="step2Form" :model="form" label-width="120px" :rules="step2Rules"
                            class="upload-form">
                            <!-- 1. 标题 -->
                            <el-form-item label="标题" prop="title">
                                <template slot="label">
                                    <span style="color: #fff">标题 </span>
                                </template>
                                <el-input v-model="form.title" placeholder="请输入标题，5-200个字以内，用空格隔开" show-word-limit
                                    @blur="validateField('title', 'step2Form')" style="width: 100%;" />
                                <div class="form-tip">标题最多输入200个字符</div>
                            </el-form-item>

                            <!-- 2. 分类（一级+二级） -->
                            <el-form-item label="分类" prop="category">
                                <template slot="label">
                                    <span style="color: #fff">分类 </span>
                                </template>
                                <div class="category-container">
                                    <el-select :popper-append-to-body="false" v-model="form.category"
                                        placeholder="选择一级分类"
                                        @change="() => { handleFirstCategoryChange(form.category); validateField('category', 'step2Form'); }"
                                        @blur="validateField('category', 'step2Form')"
                                        style="width: 180px; margin-right: 15px;">
                                        <el-option v-for="item in onetype" :key="item.value" :label="item.label"
                                            :value="item.value" />
                                    </el-select>

                                    <el-select :popper-append-to-body="false" v-model="form.secondCategory"
                                        placeholder="选择二级分类" @change="validateField('secondCategory', 'step2Form')"
                                        @blur="validateField('secondCategory', 'step2Form')" style="width: 180px;"
                                        :disabled="!form.category">
                                        <el-option v-for="item in secondCategoryList" :key="item.value"
                                            :label="item.label" :value="item.value" />
                                    </el-select>
                                </div>
                            </el-form-item>

                            <!-- 3. 模型风格 -->
                            <el-form-item label="模型风格" prop="style">
                                <template slot="label">
                                    <span style="color: #fff">模型风格 </span>
                                </template>
                                <el-select :popper-append-to-body="false" v-model="form.style" placeholder="选择风格"
                                    @change="validateField('style', 'step2Form')"
                                    @blur="validateField('style', 'step2Form')" style="width: 180px;">
                                    <el-option v-for="item in styletype" :key="item.value" :label="item.label"
                                        :value="item.value" />
                                </el-select>
                            </el-form-item>

                            <!-- 4. 布线类型 -->
                            <el-form-item label="布线类型" prop="wiringType">
                                <template slot="label">
                                    <span style="color: #fff">布线类型 </span>
                                </template>
                                <el-select :popper-append-to-body="false" v-model="form.wiringType" placeholder="选择类型"
                                    @change="validateField('wiringType', 'step2Form')"
                                    @blur="validateField('wiringType', 'step2Form')" style="width: 180px;">
                                    <el-option label="三角形" value="triangle" />
                                    <el-option label="四边形" value="quadrilateral" />
                                    <el-option label="混合" value="mixed" />
                                </el-select>
                            </el-form-item>

                            <!-- 5. 关于UV -->
                            <el-form-item label="关于UV" prop="uvStatus">
                                <template slot="label">
                                    <span style="color: #fff">关于UV </span>
                                </template>
                                <el-select :popper-append-to-body="false" v-model="form.uvStatus" placeholder="选择状态"
                                    @change="validateField('uvStatus', 'step2Form')"
                                    @blur="validateField('uvStatus', 'step2Form')" style="width: 180px;">
                                    <el-option label="未展开" value="unexpanded" />
                                    <el-option label="已展开" value="expanded" />
                                    <el-option label="部分展开" value="partial" />
                                </el-select>
                            </el-form-item>

                            <!-- 6. 模型属性 -->
                            <el-form-item label="模型属性">
                                <template slot="label">
                                    <span style="color: #fff">模型属性</span>
                                </template>
                                <el-checkbox-group v-model="form.modelProps" class="checkbox-group model-props-group">
                                    <el-checkbox label="有绑定" class="checkbox-item model-prop-item" />
                                    <el-checkbox label="有动画" class="checkbox-item model-prop-item" />
                                    <el-checkbox label="有材质" class="checkbox-item model-prop-item" />
                                    <el-checkbox label="有贴图" class="checkbox-item model-prop-item" />
                                    <!-- <el-checkbox label="使用PBR流程" class="checkbox-item model-prop-item"
                                        @change="handlePBRCheckChange" /> -->
                                </el-checkbox-group>
                            </el-form-item>

                            <!-- 7. AI内容声明 -->
                            <el-form-item>
                                <el-checkbox v-model="form.includeAI" class="ai-checkbox">
                                    <span style="color: #fff">包含AI内容（如包含AI生成内容，请勾选，否则将影响店铺权重及可能导致退款。
                                        <a href="#" style="color: #0ea5e9;">AI内容上架规则</a>）</span>
                                </el-checkbox>
                            </el-form-item>

                            <!-- 8. PBR参数描述 - 新增v-if控制显示 -->
                            <el-form-item label="PBR参数描述" prop="pbr" v-if="form.modelProps.includes('使用PBR流程')">
                                <template slot="label">
                                    <span style="color: #fff">PBR参数描述 </span>
                                </template>
                                <el-button type="text"
                                    style="color: #0ea5e9; margin-left: 8px; margin-bottom: 10px;">PBR流程说明</el-button>

                                <!-- 模型精度 -->
                                <div class="pbr-section">
                                    <div class="section-title" style="color: #fff; margin-bottom: 8px;">模型精度：</div>
                                    <el-checkbox-group v-model="form.pbr.precision" class="checkbox-group">
                                        <el-checkbox label="HIGHPLAY" class="checkbox-item" />
                                        <el-checkbox label="LODO" class="checkbox-item" />
                                        <el-checkbox label="LOD1" class="checkbox-item" />
                                        <el-checkbox label="LOD2" class="checkbox-item" />
                                        <el-checkbox label="LOD3" class="checkbox-item" />
                                        <el-checkbox label="LOD4" class="checkbox-item" />
                                        <el-checkbox label="LOD6" class="checkbox-item" />
                                    </el-checkbox-group>
                                </div>

                                <!-- 贴图分辨率 -->
                                <div class="pbr-section" style="margin-top: 10px;">
                                    <div class="section-title" style="color: #fff; margin-bottom: 8px;">贴图分辨率：</div>
                                    <el-checkbox-group v-model="form.pbr.textureRes" class="checkbox-group">
                                        <el-checkbox label="8K" class="checkbox-item" />
                                        <el-checkbox label="4K" class="checkbox-item" />
                                        <el-checkbox label="2K" class="checkbox-item" />
                                        <el-checkbox label="1K" class="checkbox-item" />
                                    </el-checkbox-group>
                                </div>

                                <!-- 贴图格式 -->
                                <div class="pbr-section" style="margin-top: 10px;">
                                    <div class="section-title" style="color: #fff; margin-bottom: 8px;">贴图格式：</div>
                                    <el-checkbox-group v-model="form.pbr.textureFormat" class="checkbox-group">
                                        <el-checkbox label="JPG" class="checkbox-item" />
                                        <el-checkbox label="PNG" class="checkbox-item" />
                                        <el-checkbox label="EXR" class="checkbox-item" />
                                        <el-checkbox label="TGA" class="checkbox-item" />
                                        <el-checkbox label="TIFF" class="checkbox-item" />
                                    </el-checkbox-group>
                                </div>

                                <!-- 色深 -->
                                <div class="pbr-section" style="margin-top: 10px;">
                                    <div class="section-title" style="color: #fff; margin-bottom: 8px;">色深：</div>
                                    <el-checkbox-group v-model="form.pbr.bitDepth" class="checkbox-group">
                                        <el-checkbox label="8bit" class="checkbox-item" />
                                        <el-checkbox label="16bit" class="checkbox-item" />
                                    </el-checkbox-group>
                                </div>

                                <!-- 贴图类型 -->
                                <div class="pbr-section" style="margin-top: 10px;">
                                    <div class="section-title" style="color: #fff; margin-bottom: 8px;">贴图类型：</div>
                                    <el-checkbox-group v-model="form.pbr.textureType" class="checkbox-group">
                                        <el-checkbox label="Diffuse" class="checkbox-item" />
                                        <el-checkbox label="Base Color" class="checkbox-item" />
                                        <el-checkbox label="Albedo" class="checkbox-item" />
                                        <el-checkbox label="Metallic" class="checkbox-item" />
                                        <el-checkbox label="Roughness" class="checkbox-item" />
                                        <el-checkbox label="Specular" class="checkbox-item" />
                                        <el-checkbox label="Glossiness" class="checkbox-item" />
                                        <el-checkbox label="Ambient Occlusion" class="checkbox-item" />
                                        <el-checkbox label="Normal" class="checkbox-item" />
                                        <el-checkbox label="Displacement (EXR Supported)" class="checkbox-item" />
                                        <el-checkbox label="Height (Bump)" class="checkbox-item" />
                                        <el-checkbox label="Emissive" class="checkbox-item" />
                                        <el-checkbox label="Opacity" class="checkbox-item" />
                                    </el-checkbox-group>
                                </div>
                            </el-form-item>

                            <!-- 9. 模型说明 -->
                            <el-form-item label="模型说明" prop="description">
                                <template slot="label">
                                    <span style="color: #fff">模型说明 </span>
                                </template>
                                <el-input type="textarea" v-model="form.description" placeholder="请输入模型说明"
                                    maxlength="5000" show-word-limit @blur="validateField('description', 'step2Form')"
                                    class="textarea-dark model-description-textarea" style="width: 100%;" />
                            </el-form-item>

                            <!-- 10. 关键词 -->
                            <el-form-item label="关键词" prop="keywords">
                                <template slot="label">
                                    <span style="color: #fff">关键词 </span>
                                </template>
                                <div class="form-tip">按回车键Enter创建标签</div>

                                <div class="keyword-container">
                                    <el-tag v-for="(tag, idx) in form.keywords" :key="idx" closable
                                        @close="removeKeyword(idx)" class="keyword-tag">
                                        {{ tag }}
                                    </el-tag>

                                    <el-input v-model="tempKeyword" placeholder="输入关键词按回车添加"
                                        @keyup.enter.native="addKeyword" @blur="validateField('keywords', 'step2Form')"
                                        class="keyword-input" size="small" />
                                </div>
                            </el-form-item>

                            <!-- 11. 上传封面 -->
                            <el-form-item label="上传封面" prop="cover">
                                <template slot="label">
                                    <span style="color: #fff">上传封面 </span>
                                </template>
                                <div class="form-tip">优质的封面会极大增加曝光</div>

                                <!-- 复用 el-upload 的 picture-card 模式，和预览图/线框图保持一致 -->
                                <el-upload class="cover-upload" list-type="picture-card" action=""
                                    :on-preview="handlePicturePreview" :on-remove="handleCoverRemove"
                                    :before-upload="beforeImageUpload" accept="image/jpeg,image/png,image/webp"
                                    :file-list="form.coverList" :limit="1"
                                    :on-exceed="(files, list) => this.$message.warning('封面只能上传1张')"
                                    :http-request="(params) => uploadFile(params, 'cover')">
                                    <i class="el-icon-plus upload-plus-icon"></i>
                                    <div slot="tip" class="upload-tip">
                                        支持JPG/PNG/WEBP格式，单张不超过1MB（优质的封面会极大增加曝光）
                                    </div>
                                </el-upload>
                            </el-form-item>

                            <!-- 12. 协议勾选 -->
                            <el-form-item prop="agreeProtocol" class="protocol-form-item">
                                <el-checkbox v-model="form.agreeProtocol"
                                    @blur="validateField('agreeProtocol', 'step2Form')" class="protocol-checkbox">
                                    <span
                                        class="protocol-text">我已阅读并同意《发布作者与网站合作协议》、《CG模型网模型授权服务协议》，并确认发布的源文件效果与配图、描述一致。<br>请确保您的发布内容资讯准确，若源文件内容与填写信息描述不一致，或因填写信息不全面导致误解，可能引发售后纠纷并须进行退款处理。</span>
                                </el-checkbox>
                            </el-form-item>

                            <!-- 表单操作按钮 -->
                            <el-form-item class="form-btn-group">
                                <el-button type="default" @click="handlePrevStep">上一步</el-button>
                                <el-button type="primary" @click="handleSubmit">下一步：提交审核</el-button>
                            </el-form-item>
                        </el-form>
                    </div>

                    <!-- 步骤3：发布等待审核 -->
                    <div v-if="currentStep === 3" class="step-content">
                        <div class="submit-success">
                            <i class="el-icon-circle-check" style="font-size: 48px; color: #10b981;"></i>
                            <h3 style="color: #fff; margin: 16px 0;">提交成功，等待审核</h3>
                            <p style="color: #94a3b8; margin-bottom: 24px;">您的模型已提交至审核队列，1-3个工作日内完成审核，结果将通过站内信通知</p>
                            <!-- <el-button type="default" @click="handlePrevStep">返回修改</el-button> -->
                            <el-button type="primary" @click="goToHome">返回首页</el-button>
                        </div>
                    </div>
                </el-card>

                <!-- 图片预览弹窗 -->
                <el-dialog title="图片预览" :visible.sync="dialogVisible" width="60%" center>
                    <img width="100%" :src="dialogImageUrl" alt="预览图" class="preview-dialog-img" />
                </el-dialog>
            </div>

            <!-- 右侧帮助面板 -->
            <div class="help-panel">
                <div class="panel-header">
                    <div class="header-left">
                        <i class="el-icon-warning"></i>
                        <span class="header-title" v-if="currentStep === 1">上传帮助</span>
                        <span class="header-title" v-if="currentStep === 2">填写帮助</span>
                        <span class="header-title" v-if="currentStep === 3">审核帮助</span>
                    </div>
                    <a href="/help/model-upload" target="_blank" class="more-help-link">查看完整指南</a>
                </div>
                <div class="panel-content">
                    <!-- 步骤1帮助 -->
                    <div v-if="currentStep === 1">
                        <div class="help-section">
                            <h4 class="section-title">压缩包要求</h4>
                            <ul class="section-list">
                                <li>支持格式：<span class="text-highlight">.zip, .rar, .7z, .tar, .gz, .bz2, .xz</span></li>
                                <li>单个文件大小上限：<span class="text-highlight">1GB</span></li>
                                <li>最多上传数量：<span class="text-highlight">5个</span></li>
                                <li>附加要求：压缩包内需包含完整模型文件及材质贴图，建议根目录包含说明文档</li>
                            </ul>
                        </div>

                        <div class="help-section">
                            <h4 class="section-title">线框图示例</h4>
                            <div class="example-imgs">
                                <div class="example-item">
                                    <img src="../../assets/example/line_border1.png" alt="线框图示例1" class="example-img"
                                        @click="handleExamplePreview('../../assets/example/line_border1.png')" />
                                    <p class="example-desc">机械模型线框图</p>
                                </div>
                                <div class="example-item">
                                    <img src="../../assets/example/line_border2.png" alt="线框图示例2" class="example-img"
                                        @click="handleExamplePreview('../../assets/example/line_border2.png')" />
                                    <p class="example-desc">建筑模型线框图</p>
                                </div>aaaaaaa3
                            </div>
                        </div>

                        <div class="help-section support-section">
                            <h4 class="section-title">需要更多帮助？</h4>
                            <div class="support-contact">
                                <i class="el-icon-phone"></i>
                                <span class="support-text">客服热线：400-123-4567（工作日9:00-18:00）</span>
                            </div>
                            <div class="support-contact">
                                <i class="el-icon-message"></i>
                                <span class="support-text">在线客服：点击页面右下角「客服」图标</span>
                            </div>
                        </div>
                    </div>

                    <!-- 步骤2帮助 -->
                    <div v-if="currentStep === 2">
                        <div class="help-section">
                            <h4 class="section-title">标题填写规范</h4>
                            <ul class="section-list">
                                <li>建议包含“模型类型+风格+核心特征”（如：“写实风格机械臂模型 高模”）</li>
                                <li>避免使用敏感词、营销词（如“最棒”“第一”）</li>
                                <li>长度控制在5-200字，用空格分隔关键词</li>
                            </ul>
                        </div>

                        <div class="help-section">
                            <h4 class="section-title">PBR参数填写说明</h4>
                            <ul class="section-list">
                                <li>模型精度：根据实际LOD级别勾选，建议至少勾选1个</li>
                                <li>贴图分辨率：填写实际导出的贴图尺寸</li>
                                <li>贴图类型：勾选模型包含的所有贴图类型，便于用户筛选</li>
                            </ul>
                        </div>

                        <div class="help-section support-section">
                            <h4 class="section-title">需要更多帮助？</h4>
                            <div class="support-contact">
                                <i class="el-icon-phone"></i>
                                <span class="support-text">客服热线：400-123-4567（工作日9:00-18:00）</span>
                            </div>
                            <div class="support-contact">
                                <i class="el-icon-message"></i>
                                <span class="support-text">在线客服：点击页面右下角「客服」图标</span>
                            </div>
                        </div>
                    </div>

                    <!-- 步骤3帮助 -->
                    <div v-if="currentStep === 3">
                        <div class="help-section">
                            <h4 class="section-title">审核进度说明</h4>
                            <ul class="section-list">
                                <li>审核周期：1-3个工作日</li>
                                <li>通知方式：站内信+邮件</li>
                                <li>不通过原因：内容不符、参数错误、侵权风险等</li>
                            </ul>
                        </div>

                        <div class="help-section support-section">
                            <h4 class="section-title">需要更多帮助？</h4>
                            <div class="support-contact">
                                <i class="el-icon-phone"></i>
                                <span class="support-text">客服热线：400-123-4567（工作日9:00-18:00）</span>
                            </div>
                            <div class="support-contact">
                                <i class="el-icon-message"></i>
                                <span class="support-text">在线客服：点击页面右下角「客服」图标</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部组件 -->
        <!-- <Bottom /> -->
    </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/index.css';
import Top from '../../components/Header.vue';
import Bottom from '../../components/Footer.vue';
import { Message } from 'element-ui';

export default {
    name: 'ModelUpload',
    components: { Top, Bottom },
    data() {
        return {
            isAuthenticated: false,       // 是否已实名认证
            showAuthModal: false,          // 是否显示认证弹窗
            authModalText: "您尚未完成实名认证，无法进行模型上传操作，请先完善实名认证信息。",
            uploadProgress: 0, // 整体上传进度（0-100）
            isModelUploading: false, // 压缩包是否正在上传（控制进度条显示/隐藏）
            currentUploadFileName: '', // 当前正在上传的压缩包名称

            currentChunkIndex: 0, // 当前正在上传的分片索引（从0开始）
            totalUploadChunks: 0, // 当前压缩包的总分片数

            coverList: [],
            FormatRenderers: [],
            currentStep: 1,
            tempKeyword: '',
            dialogVisible: false,
            dialogImageUrl: '',

            wiringTypeMap: {
                triangle: '三角形',
                quadrilateral: '四边形',
                mixed: '混合'
            },
            // 新增：UV状态中英文映射
            uvStatusMap: {
                unexpanded: '未展开',
                expanded: '已展开',
                partial: '部分展开'
            },
            // 分类数据
            onetype: [
                { label: '动物', value: '动物' },
                { label: '建筑', value: '建筑' },
                { label: '人物', value: '人物' },
                { label: '机械', value: '机械' }
            ],
            secondCategoryList: [],
            // 二级分类映射
            twotype: {
                动物: [
                    { label: '爬行动物', value: '爬行动物' },
                    { label: '哺乳动物', value: '哺乳动物' },
                    { label: '鸟类', value: '鸟类' },
                    { label: '鱼类', value: '鱼类' }
                ],
                建筑: [
                    { label: '住宅', value: '住宅' },
                    { label: '商业', value: '商业' },
                    { label: '工业', value: '工业' },
                    { label: '公共建筑', value: '公共建筑' }
                ],
                人物: [
                    { label: '男性', value: '男性' },
                    { label: '女性', value: '女性' },
                    { label: '儿童', value: '儿童' },
                    { label: '卡通人物', value: '卡通人物' }
                ],
                机械: [
                    { label: '汽车', value: '汽车' },
                    { label: '机器人', value: '机器人' },
                    { label: '工程机械', value: '工程机械' }
                ]
            },
            styletype: [
                { label: '动物', value: '动物' },
                { label: '建筑', value: '建筑' },
                { label: '人物', value: '人物' },
                { label: '机械', value: '机械' }
            ],
            form: {
                // 步骤1字段
                previewImages: [],
                previewNames: [], // 新增：存储预览图的fileName
                previewUrl: [], // 新增：预览图URL数组
                wireframeImages: [],
                wireframeNames: [], // 新增：线框图名称数组
                wireframeUrl: [], // 新增：线框图URL数组
                modelFile: [],
                modelFileNames: [], // 新增：压缩包名称数组
                fileUrl: [], // 新增：压缩包URL数组
                closePerson: false,//默认不关闭个人授权
                publishMode: '',
                authorizationPrice: null,
                // 替换为多套配置数组
                formatConfigs: [
                    {
                        fileFormat: '',
                        formatVersion: '',
                        renderer: '',
                        rendererVersion: '',
                        needFormatVersion: false,
                        needRenderer: false,
                        needRendererVersion: false,
                        rendererOptions: []
                    }
                ],

                // 步骤2字段
                title: '',
                category: '',
                secondCategory: '',
                style: '',
                wiringType: '',
                uvStatus: '',
                modelProps: [],
                bind: false, // 新增：是否有绑定
                animation: false, // 新增：是否有动画
                material: false, // 新增：是否有材质
                sticker: false, // 新增：是否有贴图
                pbrProcess: false, // 新增：是否使用PBR流程
                includeAI: false,
                aiContent: false, // 新增：标准化字段
                pbr: {
                    precision: [],
                    textureRes: [],
                    textureFormat: [],
                    bitDepth: [],
                    textureType: []
                },
                description: '',
                keywords: [],
                cover: '',
                coverName: [], // 新增：封面图名称数组
                coverUrl: [], // 新增：封面图URL数组
                agreeProtocol: false
            },

            // 步骤1校验规则
            formRules: {
                previewImages: [
                    { required: true, message: '请至少上传1张预览图', trigger: 'blur' }
                ],
                wireframeImages: [
                    { required: true, message: '请至少上传1张线框图', trigger: 'blur' }
                ],
                modelFile: [
                    { required: true, message: '请至少上传1个压缩包', trigger: 'blur' }
                ],
                publishMode: [
                    { required: true, message: '请选择发布模式', trigger: 'blur' }
                ],
                authorizationPrice: [
                    { required: true, message: '请输入个人授权价格', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (typeof value !== 'number' || isNaN(value)) {
                                return callback(new Error('价格必须为数字'));
                            }
                            if (value < 1 || value > 999999999) {
                                return callback(new Error('价格范围：1-999999999云币'));
                            }
                            callback();
                        },
                        trigger: 'blur'
                    }
                ],
                // 多套配置的整体校验
                formatConfigs: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!Array.isArray(value) || value.length === 0) {
                                return callback(new Error('请至少配置一套文件格式信息'));
                            }
                            // 校验每套配置的必填项
                            const errors = [];
                            value.forEach((config, index) => {
                                if (!config.fileFormat) {
                                    errors.push(`第${index + 1}套配置：请选择文件格式`);
                                }
                                if (config.needFormatVersion && !config.formatVersion) {
                                    errors.push(`第${index + 1}套配置：请输入格式版本`);
                                }
                                if (config.needRenderer && !config.renderer) {
                                    errors.push(`第${index + 1}套配置：请选择渲染器`);
                                }
                                if (config.needRendererVersion && !config.rendererVersion) {
                                    errors.push(`第${index + 1}套配置：请输入渲染器版本`);
                                }
                            });
                            if (errors.length > 0) {
                                return callback(new Error(errors.join('；')));
                            }
                            callback();
                        },
                        trigger: 'blur'
                    }
                ]
            },

            // 步骤2校验规则
            step2Rules: {
                title: [
                    { required: true, message: '请输入标题', trigger: ['blur', 'change'] },
                    { min: 5, max: 200, message: '标题长度需在5-200个字符之间', trigger: ['blur', 'change'] }
                ],
                category: [
                    { required: true, message: '请选择一级分类', trigger: ['blur', 'change'] }
                ],
                secondCategory: [
                    { required: true, message: '请选择二级分类', trigger: ['blur', 'change'] }
                ],
                style: [
                    { required: true, message: '请选择模型风格', trigger: ['blur', 'change'] }
                ],
                wiringType: [
                    { required: true, message: '请选择布线类型', trigger: ['blur', 'change'] }
                ],
                uvStatus: [
                    { required: true, message: '请选择UV状态', trigger: ['blur', 'change'] }
                ],
                description: [
                    { required: true, message: '请输入模型说明', trigger: 'blur' },
                    { min: 10, max: 5000, message: '模型说明长度需在10-5000个字符之间', trigger: 'blur' }
                ],
                keywords: [
                    {
                        required: true,
                        message: '请至少添加一个关键词',
                        trigger: ['blur', 'change'],
                        validator: (rule, value, callback) => {
                            if (value && value.length > 0) {
                                callback();
                            } else {
                                callback(new Error('请至少添加一个关键词'));
                            }
                        }
                    }
                ],
                cover: [
                    {
                        required: true,
                        message: '请上传封面图片',
                        trigger: 'change',
                        validator: (rule, value, callback) => {
                            if (this.form.coverList.length === 0) {
                                callback(new Error('请上传封面图片'));
                            } else {
                                callback();
                            }
                        }
                    }
                ],
                agreeProtocol: [
                    {
                        required: true, message: '请阅读并同意相关协议', trigger: 'blur', validator: (rule, value, callback) => {
                            value ? callback() : callback(new Error('请阅读并同意相关协议'));
                        }
                    }
                ]
            }
        };
    },
    watch: {
        'form.modelProps'(newVal) {
            this.form.bind = newVal.includes('有绑定');
            this.form.animation = newVal.includes('有动画');
            this.form.material = newVal.includes('有材质');
            this.form.sticker = newVal.includes('有贴图');
            this.form.pbrProcess = newVal.includes('使用PBR流程');
        },
        'form.includeAI'(newVal) {
            this.form.aiContent = newVal;
        }
    },
    computed: {
        // 移除旧的单个配置计算属性，改为针对具体索引的方法
    },
    created() {
        this.getFormatRenderers();
        this.getQueryCategory();
    },
    mounted() {
        this.checkAuthStatus().then(() => {
            if (this.isAuthenticated) {
                this.getFormatRenderers();
                this.getQueryCategory();
            }
        });
    },
    methods: {
        // 查询实名认证状态
        async checkAuthStatus() {
            try {
                const res = await this.$apiFun.getSeleMerchantCA();
                if (res.status === 200 || res.code === 200) {
                    this.isAuthenticated = !!res.obj?.merchantCA;
                    // 未认证则显示弹窗
                    if (!this.isAuthenticated) {
                        this.showAuthModal = true;
                    }
                } else {
                    this.$message.error("认证状态查询失败");
                    this.showAuthModal = true; // 查询失败默认视为未认证
                }
            } catch (err) {
                this.$message.error('认证状态查询失败');
                console.error('查询认证状态出错：', err);
                this.showAuthModal = true;
            }
        },

        // 跳转到实名认证页面
        goToAuthPage() {
            this.showAuthModal = false;
            // 替换为实际实名认证页面路由
            this.$router.push('/dashboard/seller/info');
        },

        // 拦截操作：检查认证状态（通用方法）
        checkAuthBeforeAction(action) {
            if (!this.isAuthenticated) {
                this.showAuthModal = true;
                return false;
            }
            action(); // 认证通过则执行原操作
            return true;
        },
        getQueryCategory() {
            this.$apiFun.getQueryCategory().then(res => {
                if (res.status === 200) {
                    this.onetype = res.obj.onetype;
                    this.twotype = res.obj.twotype;
                    this.styletype = res.obj.styletype;
                } else {
                    this.$message.error(res.msg || '类别查询失败');
                }
            }).catch(err => {
                this.$message.error('查询类别接口调用失败');
            });
        },
        // 新增：压缩包分片上传核心辅助方法（带进度条）
        async chunkUploadModelFile(file, params) {
            const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB 分片
            const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
            const originalFileName = file.name;
            let finalFileUrl = '';

            // ========== 上传前：初始化所有进度相关数据 ==========
            this.uploadProgress = 0;
            this.isModelUploading = true;
            this.currentUploadFileName = originalFileName;
            this.currentChunkIndex = 0; // 初始化当前分片索引
            this.totalUploadChunks = totalChunks; // 存储总分片数
            const singleChunkProgressWeight = 100 / totalChunks; // 单个分片占整体进度的权重
            const currentTimestampMs = Date.now();

            try {
                // 循环上传所有分片
                for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
                    // 1. 先更新当前分片索引（实时反馈到页面）
                    this.currentChunkIndex = chunkIndex;

                    // 2. 切割当前分片（原有逻辑不变）
                    const start = chunkIndex * CHUNK_SIZE;
                    const end = Math.min(start + CHUNK_SIZE, file.size);
                    const chunkBlob = file.slice(start, end);

                    // 3. 构造 FormData（原有逻辑不变）
                    const formData = new FormData();
                    formData.append("file", chunkBlob);
                    formData.append("chunkIndex", chunkIndex);
                    formData.append("totalChunks", totalChunks);
                    formData.append("originalFileName", originalFileName);
                    formData.append("isLastChunk", chunkIndex === totalChunks - 1);
                    formData.append("id", currentTimestampMs);

                    // 4. 上传当前分片（移除 onUploadProgress，简化配置）
                    // 注意：不再依赖单个分片的上传细节，只关注分片是否上传成功
                    const res = await this.$apiFun.postChunkUploadFile(formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        onUploadProgress: (progressEvent) => {
                            if (!progressEvent.total) return; // 避免 total 为 undefined 导致 NaN
                            // 计算当前分片的完成比例（0-1）
                            const chunkCompleteRatio = progressEvent.loaded / progressEvent.total;
                            // 计算整体进度：已完成分片权重 + 当前分片已完成权重
                            const currentProgress = (chunkIndex * singleChunkProgressWeight) + (chunkCompleteRatio * singleChunkProgressWeight);
                            // 实时更新，保留1位小数，避免波动过大
                            this.uploadProgress = Math.min(Math.round(currentProgress * 10) / 10, 100);
                        }
                    });

                    if (res.status !== 200) {
                        throw new Error(`分片 ${chunkIndex + 1} 上传失败：${res.msg || '未知错误'}`);
                    }

                    // 5. 分片上传成功后，立即更新整体进度（核心：实现实时递增）
                    this.uploadProgress = Math.min(
                        Math.round((chunkIndex + 1) * singleChunkProgressWeight), // 已完成分片数 × 单个分片权重
                        100 // 防止超出100%
                    );

                    // 6. 最后一片上传成功，获取最终文件信息（原有逻辑不变）
                    if (chunkIndex === totalChunks - 1) {
                        finalFileUrl = res.obj.fileUrl;
                        this.uploadProgress = 100; // 强制置为100%，确保进度条满格
                    }
                }

                // 分片上传&合并完成，触发成功回调
                params.onSuccess({ data: { url: finalFileUrl } }, file);
                return {
                    fileName: originalFileName,
                    fileUrl: finalFileUrl
                };
            } catch (err) {
                params.onError(err);
                this.$message.error(`压缩包分片上传失败：${err.message}`);
                // 上传失败：重置进度（可选，也可保留当前进度，方便用户知晓失败节点）
                this.uploadProgress = 0;
                return null;
            } finally {
                // 上传完成/失败：延迟重置状态（提升用户体验）
                setTimeout(() => {
                    this.isModelUploading = false;
                    this.currentUploadFileName = '';
                    this.currentChunkIndex = 0;
                    this.totalUploadChunks = 0;
                    // 保留进度条100%显示1秒后，重置为0
                    this.uploadProgress = 0;
                }, 1000);
            }
        },
        // 自定义上传方法（使用this.$apiFun.postUploadFile，自带token）
        uploadFile(params, type) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);

            // 非压缩包类型，保持原有普通上传逻辑
            if (type !== 'model') {
                this.$apiFun.postUploadFile(formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(res => {
                    if (res.status === 200) {
                        const fileUrl = res.obj.fileUrl;
                        const fileName = res.obj.fileName;
                        switch (type) {
                            case 'preview':
                                params.onSuccess({ data: { url: fileUrl } }, file);
                                this.form.previewNames.push(fileName);
                                this.form.previewUrl.push(fileUrl);
                                break;
                            case 'wireframe':
                                params.onSuccess({ data: { url: fileUrl } }, file);
                                this.form.wireframeNames.push(fileName);
                                this.form.wireframeUrl.push(fileUrl);
                                break;
                            case 'cover':
                                params.onSuccess({ data: { url: fileUrl } }, file);
                                this.form.cover = fileUrl;
                                this.form.coverName = [fileName];
                                this.form.coverUrl = [fileUrl];
                                this.form.coverList = [{
                                    name: fileName,
                                    url: fileUrl,
                                    uid: file.uid
                                }];
                                this.$message.success('封面上传成功');
                                this.validateField('cover', 'step2Form');
                                break;
                        }
                    } else {
                        params.onError(new Error(res.msg || '上传失败'));
                        this.$message.error(res.msg || '上传失败');
                    }
                }).catch(err => {
                    params.onError(err);
                    this.$message.error('上传接口调用失败');
                });
            } else {
                // ========== 核心修改：model 类型（压缩包）使用分片上传 ==========
                this.chunkUploadModelFile(file, params).then(result => {
                    if (result) {
                        // 成功后更新表单数据，和原有逻辑保持一致
                        this.form.modelFileNames.push(result.fileName);
                        this.form.fileUrl.push(result.fileUrl);
                        // this.$message.success('压缩包分片上传并合并成功');
                    }
                });
            }
        },
        // 获取格式渲染器数据
        getFormatRenderers() {
            this.$apiFun.getFormatRenderers().then(res => {
                if (res.status === 200) {
                    this.FormatRenderers = res.obj;
                } else {
                    this.$message.error(res.msg || '格式查询失败');
                }
            }).catch(err => {
                this.$message.error('查询格式接口调用失败');
            });
            // 模拟接口返回数据
            // this.FormatRenderers = [
            //     {
            //         fileFormat: '3ds Max(.max)',
            //         formatVersion: true,
            //         renderer: true,
            //         rendererVersion: [
            //             { renderer: 'V-Ray', version: true },
            //             { renderer: 'Corona', version: true },
            //             { renderer: 'Arnold', version: true }
            //         ]
            //     },
            //     {
            //         fileFormat: 'Maya(.ma)',
            //         formatVersion: true,
            //         renderer: true,
            //         rendererVersion: [
            //             { renderer: 'Arnold', version: true },
            //             { renderer: 'Redshift', version: true }
            //         ]
            //     }
            // ];
        },

        // 添加一套格式配置
        addConfig() {
            this.form.formatConfigs.push({
                fileFormat: '',
                formatVersion: '',
                renderer: '',
                rendererVersion: '',
            });
        },

        // 删除指定索引的格式配置
        removeConfig(index) {
            if (this.form.formatConfigs.length <= 1) {
                this.$message.warning('至少保留一套文件格式配置');
                return;
            }
            this.form.formatConfigs.splice(index, 1);
            // 重新校验配置项
            this.validateField('formatConfigs');
        },

        // 文件格式变更（针对指定索引）
        handleFileFormatChange(index) {
            const config = this.form.formatConfigs[index];
            const formatInfo = this.FormatRenderers.find(item => item.fileFormat === config.fileFormat) || {};

            // 重置该配置项的相关字段
            config.formatVersion = '';
            config.renderer = '';
            config.rendererVersion = '';

            // 设置是否需要显示格式版本、渲染器
            config.needFormatVersion = formatInfo.formatVersion || false;
            config.needRenderer = formatInfo.renderer || false;
            config.rendererOptions = formatInfo.rendererVersion || [];

            // 重新校验该配置项
            this.validateField(`formatConfigs[${index}].fileFormat`);
        },

        // 渲染器变更（针对指定索引）
        handleRendererChange(index) {
            const config = this.form.formatConfigs[index];
            const rendererInfo = config.rendererOptions.find(item => item.renderer === config.renderer) || {};

            // 重置渲染器版本
            config.rendererVersion = '';
            // 设置是否需要显示渲染器版本
            config.needRendererVersion = rendererInfo.version || false;

            // 重新校验该配置项
            this.validateField(`formatConfigs[${index}].renderer`);
        },

        // PBR勾选状态变更处理
        handlePBRCheckChange() {
            // 取消勾选时清空PBR参数
            if (!this.form.modelProps.includes('使用PBR流程')) {
                this.form.pbr = {
                    precision: [],
                    textureRes: [],
                    textureFormat: [],
                    bitDepth: [],
                    textureType: []
                };
            }
            // 重新校验表单
            this.$refs.step2Form?.validateField('pbr');
        },

        // 通用字段校验方法
        validateField(field, formName = 'uploadForm') {
            this.$refs[formName]?.validateField(field);
        },

        // 一级分类变更
        handleFirstCategoryChange(val) {
            this.secondCategoryList = this.twotype[val] || [];
            this.form.secondCategory = '';
            // 清空二级分类后主动校验二级分类字段
            this.validateField('secondCategory', 'step2Form');
        },

        // 图片预览
        handlePicturePreview(file) {
            this.dialogImageUrl = file.url || file.response?.data?.url;
            this.dialogVisible = true;
        },
        handleExamplePreview(imgUrl) {
            this.dialogImageUrl = imgUrl;
            this.dialogVisible = true;
        },

        // 文件移除
        handlePreviewRemove(file, fileList) {
            this.form.previewImages = fileList;

            const removeIndex = this.form.previewNames.findIndex(name => name === file.response?.data?.url);
            if (removeIndex > -1) {
                this.form.previewNames.splice(removeIndex, 1);
                this.form.previewUrl.splice(removeIndex, 1); // 新增：删除对应预览图URL
            }
        },
        handleWireframeRemove(file, fileList) {
            this.form.wireframeImages = fileList;
            const removeIndex = this.form.wireframeNames.findIndex(name => name === file.response?.data?.url);
            if (removeIndex > -1) {
                this.form.wireframeNames.splice(removeIndex, 1);
                this.form.wireframeUrl.splice(removeIndex, 1); // 新增：删除对应线框图URL
            }
        },
        handleModelFileRemove(file, fileList) {
            // 上传中禁止删除
            if (this.isModelUploading) {
                this.$message.warning("当前有压缩包正在上传，暂无法删除文件");
                return;
            }

            this.form.modelFile = fileList;
            const removeIndex = this.form.modelFileNames.findIndex(name => name === file.response?.data?.url);
            if (removeIndex > -1) {
                this.form.modelFileNames.splice(removeIndex, 1);
                this.form.fileUrl.splice(removeIndex, 1);
            }
        },

        // 文件上传成功
        handlePreviewSuccess(response, file, fileList) {
            console.log(response)
            const newFileList = fileList.map(item => {
                if (item.uid === file.uid) {
                    return { ...item, url: response.data.url }; // 用后台真实URL替换blob URL
                }
                return item;
            });
            this.form.previewImages = newFileList; // 重新赋值file-list
            this.$message.success('预览图上传成功');
        },
        handleWireframeSuccess(response, file, fileList) {
            const newFileList = fileList.map(item => {
                if (item.uid === file.uid) {
                    return { ...item, url: response.data.url }; // 用后台真实URL替换blob URL
                }
                return item;
            });
            this.form.wireframeImages = newFileList;
            this.$message.success('线框图上传成功');
        },
        handleModelFileSuccess(response, file, fileList) {
            this.form.modelFile = fileList;
            this.$message.success('压缩包上传成功');
        },
        // 新增封面移除方法（和预览图/线框图的移除逻辑一致）
        handleCoverRemove(file, fileList) {
            this.form.coverList = fileList;
            // 如果需要保留 cover 字段供提交接口使用
            this.form.cover = fileList.length > 0 ? fileList[0].url : '';
            // 新增：清空封面名称和URL数组
            this.form.coverName = [];
            this.form.coverUrl = [];
        },

        // 文件超出数量限制
        handleFileExceed(files, fileList) {
            const limitMap = {
                previewImages: 5,
                wireframeImages: 5,
                modelFile: 5
            };
            const typeMap = {
                previewImages: '预览图',
                wireframeImages: '线框图',
                modelFile: '压缩包'
            };

            // 移除file.uid.includes的判断，改用fileList对应的类型（或通过files[0].type）
            let uploadTypeKey = 'previewImages';
            if (files[0].type.includes('svg')) {
                uploadTypeKey = 'wireframeImages';
            } else if (files[0].type.includes('zip') || files[0].type.includes('rar')) {
                uploadTypeKey = 'modelFile';
            }

            this.$message.warning(`最多只能上传${limitMap[uploadTypeKey]}张/个${typeMap[uploadTypeKey]}`);
        },

        // 上传前校验
        beforeImageUpload(file) {
            let maxSize = 1; // 预览图/封面 1MB

            // 更精准的类型判断
            if (file.type.includes('svg')) {
                maxSize = 1; // 线框图 1MB
            }

            const isLtMaxSize = file.size / 1024 / 1024 <= maxSize;
            if (!isLtMaxSize) {
                this.$message.error(`单个图片大小不能超过${maxSize}MB，请压缩后重新上传`);
                return false;
            }
            return true;
        },
        beforeModelFileUpload(file) {
            // ========== 新增：上传中拦截新文件 ==========
            if (this.isModelUploading) {
                this.$message.warning(`当前正在上传「${this.currentUploadFileName}」，请等待上传完成后再上传新的压缩包`);
                return false; // 返回 false 阻止 el-upload 继续处理该文件
            }

            // 原有大小校验逻辑（保持不变）
            const isLt1GB = file.size / 1024 / 1024 / 1024 <= 1;
            if (!isLt1GB) {
                this.$message.error('单个压缩包大小不能超过1GB，请压缩后重新上传');
                return false;
            }
            return true;
        },

        // 发布模式变更
        handlePublishModeChange(value) {
            if (value === 'free') {
                this.form.authorizationPrice = null;
            }
        },

        // 关键词操作 - 修复超出提示逻辑
        addKeyword() {
            if (this.tempKeyword && !this.form.keywords.includes(this.tempKeyword)) {
                if (this.form.keywords.length >= 20) {
                    this.$message.warning('最多只能添加20个关键词');
                } else {
                    this.form.keywords.push(this.tempKeyword);
                    this.tempKeyword = '';
                    // 添加后主动触发关键词校验
                    this.validateField('keywords', 'step2Form');
                }
            }
        },
        removeKeyword(idx) {
            this.form.keywords.splice(idx, 1);
            // 删除后主动触发关键词校验
            this.validateField('keywords', 'step2Form');
        },

        // 表单重置
        handleReset() {
            this.$refs.uploadForm?.resetFields();
            this.form.previewImages = [];
            this.form.wireframeImages = [];
            this.form.modelFile = [];
            this.form.publishMode = '';
            this.form.authorizationPrice = null;
            this.form.fileUrl = []; // 新增：清空压缩包URL
            // 重置格式配置为默认一套
            this.form.formatConfigs = [
                {
                    fileFormat: '',
                    formatVersion: '',
                    renderer: '',
                    rendererVersion: '',
                    needFormatVersion: false,
                    needRenderer: false,
                    needRendererVersion: false,
                    rendererOptions: []
                }
            ];
            this.$message.info('表单已重置');
        },

        // 步骤切换
        handleNextStep() {
            this.$refs.uploadForm.validate((isValid) => {
                if (isValid) {
                    this.currentStep = 2;
                    this.$message.success('表单验证通过，进入填写介绍页面');
                } else {
                    this.$message.error('请完成所有必选项目的上传和填写');
                }
            });
        },
        handlePrevStep() {
            if (this.currentStep === 2) {
                this.currentStep = 1;
            } else if (this.currentStep === 3) {
                this.currentStep = 2;
            }
        },
        handleSubmit() {
            // 先执行表单基础校验
            this.$refs.step2Form.validate(async (isValid) => {
                if (!isValid) {
                    this.$message.error('请完成所有必选项目的填写');
                    return;
                }

                try {
                    // ========== 1. 定义参数有效性校验规则 ==========
                    const validateParams = () => {
                        // 存储校验错误信息
                        const errors = [];

                        // ------------- 字符串类型：非空校验 -------------
                        const stringFields = [
                            { key: 'title', value: this.form.title, label: '标题' },
                            { key: 'releaseModel', value: this.form.publishMode === 'free' ? '免费分享' : '素材出售', label: '发布模式' },
                            { key: 'instructions', value: this.form.description, label: '模型说明' },
                            // 分类字段（字符串源值）
                            { key: 'category', value: this.form.category, label: '一级分类' },
                            { key: 'secondCategory', value: this.form.secondCategory, label: '二级分类' },
                            { key: 'style', value: this.form.style, label: '风格分类' },
                            // 新增：布线类型、关于UV
                            { key: 'wiringType', value: this.form.wiringType, label: '布线类型' }, // 仍校验英文value
                            { key: 'aboutUV', value: this.form.uvStatus, label: '关于UV' } // 仍校验英文value
                        ];

                        stringFields.forEach(item => {
                            if (!item.value || item.value.trim() === '') {
                                errors.push(`${item.label}不能为空`);
                            }
                        });

                        // ------------- 数组类型：长度≥1校验 -------------
                        const arrayFields = [
                            { key: 'previewName', value: this.form.previewNames, label: '预览图名称' },
                            { key: 'previewUrl', value: this.form.previewUrl, label: '预览图URL' },
                            { key: 'wireframeName', value: this.form.wireframeNames, label: '线框图名称' },
                            { key: 'wireframeUrl', value: this.form.wireframeUrl, label: '线框图URL' },
                            { key: 'fileName', value: this.form.modelFileNames, label: '压缩包名称' },
                            { key: 'fileUrl', value: this.form.fileUrl, label: '压缩包URL' },
                            { key: 'coverName', value: this.form.coverName, label: '封面图名称' },
                            { key: 'coverUrl', value: this.form.coverUrl, label: '封面图URL' },
                            { key: 'keywords', value: this.form.keywords, label: '关键词' },
                            // 分类数组（包装后）
                            { key: 'oneType', value: [this.form.category], label: '一级分类数组' },
                            { key: 'twoType', value: [this.form.secondCategory], label: '二级分类数组' },
                            { key: 'styleType', value: [this.form.style], label: '风格分类数组' },
                            // 格式配置数组校验
                            { key: 'formatConfigs', value: this.form.formatConfigs, label: '文件格式配置' }
                        ];

                        arrayFields.forEach(item => {
                            if (!Array.isArray(item.value) || item.value.length === 0) {
                                errors.push(`${item.label}不能为空数组`);
                            } else if (item.key !== 'formatConfigs' && item.value.some(v => !v || v.trim() === '')) {
                                errors.push(`${item.label}包含空值，请检查`);
                            }
                        });

                        // ------------- 数值类型：有效性校验 -------------
                        const licensingPrices = this.form.publishMode === 'free'
                            ? 0
                            : (Number(this.form.authorizationPrice) || 100);
                        if (this.form.publishMode === 'sale' && (isNaN(licensingPrices) || licensingPrices <= 0)) {
                            errors.push('素材出售价格必须为大于0的数字');
                        }

                        // ------------- 布尔类型：有效性校验（确保是布尔值） -------------
                        const boolFields = [
                            { key: 'bind', value: this.form.bind, label: '是否有绑定' },
                            { key: 'animation', value: this.form.animation, label: '是否有动画' },
                            { key: 'material', value: this.form.material, label: '是否有材质' },
                            { key: 'sticker', value: this.form.sticker, label: '是否有贴图' },
                            { key: 'pbrProcess', value: this.form.pbrProcess, label: '是否使用PBR流程' },
                            { key: 'aiContent', value: this.form.aiContent, label: '是否包含AI内容' }
                        ];

                        boolFields.forEach(item => {
                            if (typeof item.value !== 'boolean') {
                                errors.push(`${item.label}必须为有效布尔值`);
                            }
                        });

                        return errors;
                    };

                    // ========== 2. 执行参数校验 ==========
                    const validateErrors = validateParams();
                    if (validateErrors.length > 0) {
                        // 拼接错误信息并提示
                        this.$message.error(`参数校验失败：\n${validateErrors.join('\n')}`);
                        return false;
                    }

                    // ========== 3. 整理接口入参（参数名: 参数值） ==========
                    // 格式化多套配置为接口需要的数组对象格式
                    const formatConfigs = this.form.formatConfigs.map(config => ({
                        fileFormat: config.fileFormat || '',
                        formatVersion: config.formatVersion || '',
                        renderer: config.renderer || '',
                        rendererVersion: config.rendererVersion || ''
                    }));

                    // 打印所有字段（含新增的布线类型、关于UV）
                    console.log('previewName: ', this.form.previewNames);
                    console.log('wireframeName: ', this.form.wireframeNames);
                    console.log('fileName: ', this.form.modelFileNames);
                    console.log('previewUrl: ', this.form.previewUrl);
                    console.log('wireframeUrl: ', this.form.wireframeUrl);
                    console.log('fileUrl: ', this.form.fileUrl);
                    const releaseModel = this.form.publishMode === 'free' ? '免费分享' : '素材出售';
                    const licensingPrices = this.form.publishMode === 'free' ? 0 : (this.form.authorizationPrice || 100);
                    console.log('releaseModel: ', releaseModel);
                    console.log('licensingPrices: ', licensingPrices);
                    console.log('closePerson: ', this.form.closePerson);
                    console.log('title: ', this.form.title);
                    console.log('oneType: ', [this.form.category]);
                    console.log('twoType: ', [this.form.secondCategory]);
                    console.log('styleType: ', [this.form.style]);
                    console.log('bind: ', this.form.bind);
                    console.log('animation: ', this.form.animation);
                    console.log('material: ', this.form.material);
                    console.log('sticker: ', this.form.sticker);
                    console.log('pbrProcess: ', this.form.pbrProcess);
                    console.log('aiContent: ', this.form.aiContent);
                    const instructions = this.form.description || '';
                    const keywords = this.form.keywords || [];
                    console.log('instructions: ', instructions);
                    console.log('keywords: ', keywords);
                    console.log('coverName: ', this.form.coverName);
                    console.log('coverUrl: ', this.form.coverUrl);
                    console.log('formatConfigs: ', formatConfigs);
                    console.log('wiringType: ', this.wiringTypeMap[this.form.wiringType]);
                    console.log('aboutUV: ', this.uvStatusMap[this.form.uvStatus]);

                    // 接口入参
                    const apiParams = {
                        // 上传文件相关
                        previewName: this.form.previewNames,
                        previewUrl: this.form.previewUrl,
                        wireframeName: this.form.wireframeNames,
                        wireframeUrl: this.form.wireframeUrl,
                        fileName: this.form.modelFileNames,
                        fileUrl: this.form.fileUrl,
                        coverName: this.form.coverName,
                        coverUrl: this.form.coverUrl,

                        // 发布模式&价格
                        releaseModel: releaseModel,
                        licensingPrices: licensingPrices,
                        closePerson: this.form.closePerson,

                        // 步骤二：标题&分类
                        title: this.form.title,
                        oneType: [this.form.category],
                        twoType: [this.form.secondCategory],
                        styleType: [this.form.style],

                        // 模型属性（布尔值）
                        bind: this.form.bind,
                        animation: this.form.animation,
                        material: this.form.material,
                        sticker: this.form.sticker,
                        pbrProcess: this.form.pbrProcess,
                        aiContent: this.form.aiContent,

                        // 模型说明&关键词
                        instructions: instructions,
                        keywords: keywords,

                        // 步骤一：文件格式&渲染器（数组对象）
                        formatConfigs: formatConfigs,

                        // 新增：布线类型、关于UV
                        wiringType: this.wiringTypeMap[this.form.wiringType],
                        aboutUV: this.uvStatusMap[this.form.uvStatus],
                    };

                    // ========== 4. 调用接口 ==========
                    const res = await this.$apiFun.postAddFileDate(apiParams);

                    // 接口成功处理
                    if (res && res.status === 200) { // 根据实际接口返回格式调整
                        this.$message.success('模型信息提交审核成功');
                        this.currentStep = 3;
                    } else {
                        this.$message.error(`提交失败：${res?.msg || '接口返回异常'}`);
                    }

                } catch (error) {
                    // 异常捕获
                    console.error('提交审核接口调用失败：', error);
                    this.$message.error('提交审核失败，请稍后重试');
                }
            });
        },
        goToHome() {
            // 跳转到首页逻辑
            this.$router.push('/');
        }
    }
};
</script>

<style lang="less" scoped>
// 全局变量
@base-deep: #0f1118;
@base-darker: #080a12;
@primary: #0ea5e9;
@primary-light: #38bdf8;
@primary-dark: #0284c7;
@accent: #7c3aed;
@text-primary: #ffffff;
@text-secondary: #94a3b8;
@text-tip: #718096; // 浅灰色提示文本
@text-highlight: #f0abfc;
@border-color: rgba(148, 163, 184, 0.15);
@tip-color: #cbd5e1;
@success-color: #10b981;
@warning-color: #f59e0b;
@error-color: #ef4444;
@shadow-light: 0 2px 15px rgba(14, 165, 233, 0.1);
@shadow-medium: 0 4px 20px rgba(14, 165, 233, 0.15);

/* 实名认证弹窗样式 */
.auth-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;

    .auth-modal-content {
        background-color: #2c2c2c;
        border-radius: 8px;
        width: 400px;
        padding: 30px 20px;
        text-align: center;

        .auth-modal-title {
            font-size: 20px;
            color: #e0e0e0;
            margin-bottom: 15px;
            font-weight: 500;
        }

        .auth-modal-desc {
            font-size: 14px;
            color: #a0a0a0;
            line-height: 1.8;
            margin-bottom: 20px;
        }

        .auth-modal-btn {
            background-color: #0ea5e9;
            color: #fff;
            border: none;
            padding: 10px 20px;
            border-radius: 4px;
            font-size: 16px;
            cursor: pointer;
            width: 100%;
            max-width: 200px;
        }
    }
}

// 页面容器
.model-upload-container {
    width: 100%;
    min-height: 100vh;
    background-color: @base-deep;
    color: @text-primary;
}

// 步骤条
.steps {
    width: 100%;
    height: 100px;
    padding: 0 40px;
    background-color: @base-darker;
    box-shadow: @shadow-light;
    position: sticky;
    top: 60px;
    z-index: 10;

    .steps-wrapper {
        width: 100%;
        max-width: 800px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .step-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 120px;

            .step-icon {
                width: 40px;
                height: 40px;
                border-radius: 10%;
                background-color: @base-deep;
                border: 2px solid @text-secondary;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 8px;
                transition: all 0.3s;

                i {
                    font-size: 18px;
                    color: @text-secondary;
                    transition: all 0.3s;
                }
            }

            .step-text {
                font-size: 14px;
                color: @text-secondary;
                transition: all 0.3s;
            }

            &.step-active {
                .step-icon {
                    background-color: @primary;
                    border-color: @primary;

                    i {
                        color: #fff;
                    }
                }

                .step-text {
                    color: @primary;
                    font-weight: 500;
                }
            }
        }

        .step-line {
            flex: 1;
            height: 2px;
            margin: 0 10px;
            transition: all 0.3s;

            &.step-line-inactive {
                background-color: @border-color;
            }

            &.step-line-active {
                background-color: @primary;
            }
        }
    }
}

// 主体内容
.main {
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 30px;
    display: flex;
    gap: 30px;
    box-sizing: border-box;

    .upload-content {
        flex: 1;

        ::v-deep .el-upload--picture-card {
            background-color: @base-darker !important;
            border: 1px dashed @border-color;
        }

        .upload-card {
            background-color: @base-darker;
            border: 1px solid @border-color;
            border-radius: 8px;
            padding: 25px;

            .upload-form {
                width: 100%;

                // 提示文本样式
                .form-tip {
                    color: @text-tip;
                    font-size: 12px;
                    margin-top: 4px;
                    line-height: 1.4;
                }

                .form-item {
                    margin-bottom: 25px;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }

                // 分类容器
                .category-container {
                    display: flex;
                    align-items: center;
                }

                // PBR参数区域
                .pbr-section {
                    margin-bottom: 10px;

                    .checkbox-group {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 15px;
                        margin-top: 10px;
                    }

                    .checkbox-item {
                        color: @text-primary;
                        font-size: 14px;
                    }
                }

                // 深色系多行文本框
                .textarea-dark {
                    ::v-deep .el-textarea__inner {
                        background-color: @base-deep;
                        border: 1px solid @border-color;
                        color: @text-primary;
                        resize: vertical;

                        &:focus {
                            border-color: @primary;
                            box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2);
                        }
                    }

                    // 字数限制透明背景
                    ::v-deep .el-input__count {
                        background-color: transparent;
                        color: @text-secondary;

                        &:hover {
                            background-color: transparent;
                        }
                    }
                }

                // 模型说明文本框 - 高度调整
                .model-description-textarea {
                    ::v-deep .el-textarea__inner {
                        min-height: 200px; // 增加基础高度
                        padding-bottom: 30px; // 预留字数统计空间
                    }

                    ::v-deep .el-input__count {
                        position: absolute;
                        bottom: 8px;
                        right: 10px;
                        background-color: transparent !important;
                        color: @text-secondary !important;
                    }

                    position: relative;
                }

                // 模型属性复选框样式
                .model-props-group {
                    .model-prop-item {
                        color: @text-primary !important; // 与AI内容字体颜色一致
                        font-size: 14px;

                        ::v-deep .el-checkbox__label {
                            color: @text-primary !important;
                        }
                    }
                }

                // 关键词容器
                .keyword-container {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    gap: 8px;
                    padding: 8px;
                    background-color: @base-deep;
                    border: 1px solid @border-color;
                    border-radius: 4px;
                    min-height: 40px;

                    .keyword-tag {
                        background-color: rgba(14, 165, 233, 0.1);
                        color: @primary;
                        border: 1px solid @border-color;
                    }

                    .keyword-input {
                        flex: 1;
                        min-width: 120px;
                        border: none;

                        ::v-deep .el-input__inner {
                            background-color: transparent;
                            border: none;
                            padding: 0;
                            color: @text-primary;

                            &:focus {
                                box-shadow: none;
                            }
                        }
                    }
                }

                // 封面上传样式
                .cover-uploader {
                    margin-top: 8px;

                    .cover-preview {
                        width: 200px;
                        height: 120px;
                        border: 1px solid @border-color;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        overflow: hidden;

                        .cover-img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }

                    .cover-upload-btn {
                        width: 200px;
                        height: 120px;
                        border: 1px dashed @border-color;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        color: @text-secondary;
                        cursor: pointer;

                        i {
                            font-size: 24px;
                            margin-bottom: 8px;
                        }

                        &:hover {
                            color: @primary;
                            border-color: @primary;
                        }
                    }
                }

                // 协议勾选样式
                .protocol-form-item {
                    padding-left: 0 !important; // 移除默认的label宽度padding

                    .protocol-checkbox {
                        display: flex;
                        align-items: flex-start;

                        ::v-deep .el-checkbox__input {
                            margin-top: 2px;
                            margin-right: 8px;
                        }

                        .protocol-text {
                            color: @text-primary !important;
                            line-height: 1.6;
                            font-size: 14px;

                            a {
                                color: #0ea5e9;
                            }
                        }
                    }
                }

                // 按钮组
                .form-btn-group {
                    display: flex;
                    justify-content: flex-end;
                    gap: 15px;
                    margin-top: 30px;

                    .el-button {
                        padding: 8px 20px;
                        font-size: 14px;

                        &.el-button--default {
                            background-color: @base-deep;
                            border-color: @border-color;
                            color: @text-primary;

                            &:hover {
                                background-color: #1e293b;
                                border-color: @text-secondary;
                            }
                        }

                        &.el-button--primary {
                            background-color: @primary;
                            border-color: @primary;

                            &:hover {
                                background-color: @primary-light;
                                border-color: @primary-light;
                            }

                            &:disabled {
                                background-color: #0284c780;
                                border-color: #0284c780;
                            }
                        }
                    }
                }
            }

            // 标题/输入框字数限制透明背景 - 重点修复
            ::v-deep .el-input__count {
                background-color: transparent !important;
                color: @text-secondary !important;
                box-shadow: none !important;
                border: none !important;

                &:hover {
                    background-color: transparent !important;
                }

                // 字数统计数字样式
                span {
                    color: @text-secondary !important;
                }
            }

            // 提交成功区域
            .submit-success {
                text-align: center;
                padding: 60px 0;

                i {
                    color: @success-color;
                    margin-bottom: 16px;
                }

                h3 {
                    color: @text-primary;
                    margin: 16px 0;
                }

                p {
                    color: @text-secondary;
                    margin-bottom: 24px;
                }
            }
        }
    }

    // 帮助面板
    .help-panel {
        width: 360px;
        min-width: 360px; // 固定最小宽度，防止被挤压
        flex-shrink: 0; // 禁止侧边栏收缩
        background-color: @base-darker;
        border: 1px solid @border-color;
        border-radius: 8px;
        padding: 20px;
        align-self: flex-start;
        box-sizing: border-box;

        .panel-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 18px;
            padding-bottom: 12px;
            border-bottom: 1px solid @border-color;

            .header-left {
                display: flex;
                align-items: center;

                i {
                    color: @warning-color;
                    font-size: 16px;
                    margin-right: 8px;
                }

                .header-title {
                    font-size: 16px;
                    font-weight: 500;
                    color: @text-primary;
                }
            }

            .more-help-link {
                font-size: 13px;
                color: @primary;
                text-decoration: none;

                &:hover {
                    color: @primary-light;
                    text-decoration: underline;
                }
            }
        }

        .panel-content {
            font-size: 14px;
            color: @text-secondary;
            line-height: 1.7;

            .help-section {
                margin-bottom: 22px;
                padding-bottom: 18px;
                border-bottom: 1px solid @border-color;

                &:last-child {
                    border-bottom: none;
                    margin-bottom: 0;
                    padding-bottom: 0;
                }

                .section-title {
                    font-size: 15px;
                    color: @text-primary;
                    margin-bottom: 12px;
                    font-weight: 500;
                }

                .section-list {
                    padding-left: 20px;
                    list-style-type: disc;

                    li {
                        margin-bottom: 8px;

                        .text-highlight {
                            color: @text-highlight;
                            font-weight: 500;
                        }
                    }
                }

                .example-imgs {
                    display: flex;
                    gap: 12px;
                    margin: 12px 0;

                    .example-item {
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        align-items: center;

                        .example-img {
                            width: 100%;
                            height: 120px;
                            object-fit: cover;
                            border-radius: 4px;
                            border: 1px solid @border-color;
                            cursor: pointer;
                            transition: all 0.3s;

                            &:hover {
                                transform: scale(1.03);
                                border-color: @primary;
                                box-shadow: 0 0 8px rgba(14, 165, 233, 0.2);
                            }
                        }

                        .example-desc {
                            font-size: 12px;
                            color: @text-tip;
                            margin-top: 8px;
                            text-align: center;
                        }
                    }
                }

                .support-contact {
                    display: flex;
                    align-items: center;
                    margin-bottom: 8px;

                    i {
                        color: @primary;
                        font-size: 16px;
                        margin-right: 8px;
                        width: 16px;
                        text-align: center;
                    }

                    .support-text {
                        font-size: 13px;
                        color: @text-secondary;
                    }
                }
            }
        }
    }
}

// 发布模式样式
.publish-mode-group {
    display: flex;
    gap: 20px;
    margin-top: 15px;
}

.publish-mode-item {
    color: @text-primary;
    display: flex;
    align-items: center;
    font-size: 14px;

    ::v-deep .el-radio__input.is-checked .el-radio__inner {
        border-color: @primary;
        background-color: @primary;
    }

    ::v-deep .el-radio__input.is-checked+.el-radio__label {
        color: @primary;
    }
}

// 价格输入框
.price-input-container {
    margin-top: 15px;
    margin-left: 120px;
}

.price-input-item {
    margin-bottom: 0;
}

.price-input {
    width: 220px;
    background-color: @base-deep;
    border-color: @border-color;
    color: @text-primary;

    ::v-deep .el-input__inner {
        background-color: @base-deep;
        border-color: @border-color;
        color: @text-primary;
    }

    ::v-deep .el-input-group__append {
        background-color: #1e293b;
        border-color: @border-color;
        color: @text-secondary;
    }
}

// 下拉框/输入框样式适配
::v-deep {

    // 下拉框面板
    .el-select-dropdown {
        background-color: @base-darker !important;
        border: 1px solid @border-color !important;
        border-radius: 4px !important;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3) !important;
    }

    // 下拉选项
    .el-select-dropdown__item {
        color: @text-primary !important;
        padding: 8px 16px !important;
        line-height: 17px !important;

        &:hover {
            background-color: #1e293b !important;
        }

        &.selected {
            background-color: rgba(14, 165, 233, 0.2) !important;
            color: @primary !important;
            font-weight: 500 !important;
        }
    }

    // 下拉框滚动条
    .el-select-dropdown__wrap::-webkit-scrollbar {
        width: 6px !important;
    }

    .el-select-dropdown__wrap::-webkit-scrollbar-track {
        background: @base-deep !important;
    }

    .el-select-dropdown__wrap::-webkit-scrollbar-thumb {
        background: rgba(148, 163, 184, 0.3) !important;
        border-radius: 3px !important;

        &:hover {
            background: rgba(148, 163, 184, 0.5) !important;
        }
    }

    // 输入框/下拉框输入区域
    .el-input__inner,
    .el-select__input {
        background-color: @base-deep !important;
        border-color: @border-color !important;
        color: @text-primary !important;
    }

    .el-select .el-input__suffix {
        color: @text-secondary !important;
    }

    // 输入框聚焦状态
    .el-input__inner:focus,
    .el-select__input:focus {
        border-color: @primary !important;
        box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;
    }

    // 错误提示
    .el-form-item__error {
        color: @error-color !important;
    }

    // 复选框样式
    .el-checkbox__inner {
        background-color: @base-deep !important;
        border-color: @border-color !important;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: @primary !important;
        border-color: @primary !important;
    }

    // AI复选框和模型属性复选框文字颜色统一
    .el-checkbox__label {
        color: @text-primary !important;
    }
}

// 响应式适配
@media screen and (max-width: 1200px) {
    .main {
        flex-direction: column;
        padding: 20px;

        .help-panel {
            width: 100%;
            max-width: 100%;
        }
    }
}

@media screen and (max-width: 768px) {
    .steps {
        padding: 0 20px;

        .steps-wrapper {
            .step-item {
                width: 80px;

                .step-text {
                    font-size: 12px;
                    text-align: center;
                }
            }
        }
    }

    .publish-mode-group {
        flex-direction: column;
        gap: 10px;
    }

    .price-input-container {
        margin-left: 0;
    }

    .price-input {
        width: 100%;
    }

    .upload-card {
        padding: 15px;

        .form-btn-group {
            flex-direction: column;
            gap: 10px;

            .el-button {
                width: 100%;
            }
        }

        .category-container {
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;

            .el-select {
                width: 100% !important;
                margin-right: 0 !important;
            }
        }

        // 移动端协议文字适配
        .protocol-form-item {
            .protocol-checkbox {
                flex-direction: column;
                align-items: flex-start;

                ::v-deep .el-checkbox__input {
                    margin-bottom: 8px;
                }
            }
        }
    }
}

.upload-tip {
    color: @tip-color
}

// 穿透修改格式选择表单项的校验提示位置
::v-deep .format-select-form-item {

    // 调整表单项布局为flex，让标签和选择框垂直排列
    .el-form-item__content {
        display: flex;
        flex-direction: column;
        align-items: flex-start; // 左对齐，和标签对齐
    }

    // 校验提示移到选择框下方
    .el-form-item__error {
        position: static !important; // 取消默认绝对定位
        margin-top: 4px !important; // 选择框和提示之间的间距
        padding-left: 0 !important; // 取消默认左padding
        line-height: 1.2; // 调整行高
        font-size: 12px;
        color: #f56c6c; // 保持错误色
    }

    // 选择框宽度控制（可选）
    .format-select {
        width: 100%;
        max-width: 300px;
    }
}

.model-upload-progress {
    ::v-deep .el-progress-bar {
        //background-color: #1e293b; // 进度条背景色（深色适配）
        background-color: transparent; // 进度条背景色（深色适配）
    }

    ::v-deep .el-progress-bar__inner {
        background-color: #0ea5e9; // 进度条颜色（和页面主色一致）
    }

    ::v-deep .el-progress-bar__inner-text {
        color: #ffffff; // 进度条文字颜色（白色，提升可读性）
        font-size: 12px;
    }
}

.model-file-upload {
    ::v-deep .el-upload--text {
        &.is-disabled {

            // 禁用状态下的按钮样式
            .el-button {
                background-color: #1e293b !important;
                border-color: #334155 !important;
                color: #94a3b8 !important;
                cursor: not-allowed !important;
                opacity: 0.7;
            }

            // 禁用状态下的提示文本样式
            .upload-tip {
                color: #64748b !important;
                opacity: 0.7;
            }
        }
    }
}
</style>